import { Chart } from "react-google-charts";
export const Barchart = ({data}) =>{
     const options = {
        title: "",
        hAxis: {
            title: "Months",
            // slantedText: true,       // ✅ makes month labels visible and angled
            slantedTextAngle: 45,    // ✅ adjust label angle
            // showTextEvery: 1, 
        },
        vAxis: {
            title: "Sales",
            format: "short", 
        },
        bar: { groupWidth: "75%" },
        legend: { position: "top" },
     };
     return (
        <Chart
            chartType="ColumnChart"
            data={data}
            options={options}
            />
     );
} 